module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-es-c53747b1f54f6b8807d5fefe243920bf.svg";